
/**
 * 去除两边指定字符
 * @param {*} str
 * @param {*} char
 * @param {*} type
 * @returns
 */
export const trim = (str, char, type) => {
  if (char) {
    if (type === 'left') {
      return str.replace(new RegExp('^\\' + char + '+', 'g'), '')
    } else if (type === 'right') {
      return str.replace(new RegExp('\\' + char + '+$', 'g'), '')
    }
    return str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '')
  }
  return str.replace(/^\s+|\s+$/g, '')
}

/**
 * 把对象展昭属性名字母顺序进行排序
 * @param {object} obj 对象
 * @returns object
 */
export const objKeySort = (obj) => {
  // 排序的函数
  var newkey = Object.keys(obj).sort()
  // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {}
  // 创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    // 遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]]
    // 向新创建的对象中按照排好的顺序依次增加键值对
  }
  // 返回排好序的新对象
  return newObj
}

/**
 * 判断变量是否为空，
 * @param  {[type]}  param 变量
 * @return {Boolean}      为空返回true，否则返回false。
 */
export const isEmpty = (param) => {
  if (param) {
    var paramType = typeof (param)
    if (paramType === 'object') {
      // 要判断的是【对象】或【数组】或【null】等
      if (typeof (param.length) === 'undefined') {
        if (JSON.stringify(param) === '{}') {
          // 空值，空对象
          return true
        }
      } else if (param.length === 0) {
        return true
        // 空值，空数组
      }
    } else if (paramType === 'string') {
      // 如果要过滤空格等字符
      var newParam = param.trim()
      if (newParam.length === 0) {
        // 空值，例如:带有空格的字符串" "。
        return true
      }
    } else if (paramType === 'boolean') {
      if (!param) {
        return true
      }
    } else if (paramType === 'number') {
      if (!param) {
        return true
      }
    }
    return false // 非空值
  } else {
    // 空值,例如：
    // (1)null
    // (2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
    // (3)空字符串''、""。
    // (4)数字0、00等，如果可以只输入0，则需要另外判断。
    return true
  }
}

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  let len = Math.min(arr1.length, arr2.length)
  let i = -1
  let res = []
  while (++i < len) {
    const item = arr2[i]
    if (arr1.indexOf(item) > -1) res.push(item)
  }
  return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
  const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
  return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timestamp
 * @timestampToDate 时间戳转日期
 */
export const timestampToDate = (timestamp, hasWeek) => {
  function toRound (date) {
    return (date < 10 ? '0' + date : date)
  }
  let d = new Date(timestamp * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let yyyy = d.getFullYear() + '-'
  let MM = toRound(d.getMonth() + 1) + '-'
  let dd = toRound(d.getDate()) + ' '
  let HH = toRound(d.getHours()) + ':'
  let mm = toRound(d.getMinutes()) + ':'
  let ss = toRound(d.getSeconds())
  let week = ''
  if (hasWeek) {
    switch (d.getDay()) {
      case 0:
        week = '周日 '
        break
      case 1:
        week = '周一 '
        break
      case 2:
        week = '周二 '
        break
      case 3:
        week = '周三 '
        break
      case 4:
        week = '周四 '
        break
      case 5:
        week = '周五 '
        break
      case 6:
        week = '周六 '
        break
    }
    return yyyy + MM + dd + week + HH + mm + ss
  } else {
    return yyyy + MM + dd + HH + mm + ss
  }
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) return 'IE'
  else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) return key in obj
  else {
    let keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}



// WEBPACK FOOTER //
// ./src/libs/tools.js